import styled from 'styled-components';
import { screenTypes } from '../../../common/Helpers/screenTypes';

export const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  padding: 20px 0px 0px 0px;
  background: rgb(255, 255, 255);
  z-index: 1;
  @media ${screenTypes.mobileL} {
    padding: 16px 10px 16px 10px;
    button {
      margin: 0 auto;
      width: 100%;
    }
  }
`;
